package org.example.zone360.pages.dashboard.clubKeywords

import org.example.zone360.components.debugPrintln

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.createKeywords
import org.example.zone360.utils.getCustomKeyword
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.KeywordInput
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.CustomKeywordPayload
import org.example.zone360.models.KeywordsPayload
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun AddKeywords(
    onDialogDismiss: () -> Unit = {},
    breakpoint: Breakpoint,
    toastMessageCall: (String) -> Unit,
) {

    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()
    var isLoading by remember { mutableStateOf(false) }
    var selectedCategory by remember { mutableStateOf("Selected Category") }
    var selectedLanguages by remember { mutableStateOf("Select Language") }
    var serverError by remember { mutableStateOf("") }
    var isCategoryError by remember { mutableStateOf(false) }
    var isLanguageError by remember { mutableStateOf(false) }
    val keywordsList = remember { mutableStateListOf<String>() }
    var keywordInputText by remember { mutableStateOf("") }
    var keywordError by remember { mutableStateOf(false) }
    var keywordErrorText by remember { mutableStateOf("") }


    Box(
        modifier = Modifier.width(if (breakpoint < Breakpoint.MD) 90.percent else 500.px)
            .id("add-keywords-Modal-").position(Position.Fixed).zIndex(9).top(50.percent)
            .left(50.percent).transform { translate((-50).percent, (-50).percent) },
        contentAlignment = Alignment.Center,
    ) {
        Box(modifier = Modifier.width(90.percent).height(90.percent).onClick { })
        Box(
            modifier = Modifier.padding(all = 24.px).width(90.percent).margin(top = 10.px)
                .height(95.percent).backgroundColor(sitePalette.modalBackgroundColor.rgb).border(
                    width = 1.px,
                    color = sitePalette.textFieldBorderColor.rgb,
                    style = LineStyle.Solid
                ).borderRadius(4.px),
            contentAlignment = Alignment.Center,
        ) {
            Column(modifier = Modifier.fillMaxSize()) {
                Row(
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 20.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column {
                        FieldTitleTextNormalSimple("Add New Keywords",
                            fontSize = 20.px,
                            fontWeight = 600,
                            onClick = {})
                    }

                    FaXmark(
                        modifier = Modifier.color(sitePalette.commonButtonSupportiveTextColor.rgb)
                            .cursor(Cursor.Pointer).onClick { onDialogDismiss() },
                        size = IconSize.LG
                    )

                }
                Column(
                    Modifier.fillMaxWidth().maxHeight(580.px),
                    verticalArrangement = Arrangement.Center
                ) {
                    Column(modifier = Modifier.fillMaxWidth(if (window.screen.width < 650) 100.percent else 100.percent)) {

                        FieldTitleTextNormalSimple(
                            "Keywords",
                            fontSize = 15.px,
                            marginTop = 10.px,
                            marginBottom = 5.px
                        )
                        KeywordInput(
                            height = 45.px,
                            keywords = keywordsList,
                            inputValue = keywordInputText,
                            onInputValueChange = { keywordInputText = it },
                            isError = keywordError,
                            onKeywordAdded = {
                                keywordError = false
                            },

                            )
                        if (keywordError) {
                            CustomSpacer(height = 4.px)
                            FieldTitleTextNormalSimple(
                                keywordErrorText,
                                color = sitePalette.textErrorColor.rgb,
                                fontSize = 11.px
                            )
                        }

                    }
                    CustomSpacer(height = 20.px)
                    FieldTitleTextNormal(text = "Category", fontSize = 14.px, onClick = {})
                    Column(modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)) {
                        CommonDropdown(
                            data = Strings.CATEGORY_LIST,
                            onSelect = {
                                selectedCategory = it
                                isCategoryError = false
                            },
                            selectedItem = selectedCategory,
                            width = 100.percent,
                        )
                        if (isCategoryError) {
                            FieldTitleTextNormal(marginTop = 3.px,
                                fontSize = 11.px,
                                text = "Please select category",
                                color = sitePalette.textErrorColor.rgb,
                                onClick = {})
                        }
                    }
                    FieldTitleTextNormal(text = "Language", fontSize = 14.px, onClick = {})
                    Column(modifier = Modifier.fillMaxWidth().margin(bottom = 20.px)) {
                        CommonDropdown(
                            data = Strings.LANGUAGES_LIST_ADD,
                            onSelect = {
                                selectedLanguages = it
                                isLanguageError = false
                            },
                            selectedItem = selectedLanguages,
                            width = 100.percent,
                        )
                        if (isLanguageError) {
                            FieldTitleTextNormal(marginTop = 3.px,
                                fontSize = 11.px,
                                text = "Please select language",
                                color = sitePalette.textErrorColor.rgb,
                                onClick = {})
                        }
                    }
                }

                Box(
                    modifier = Modifier.fillMaxWidth().padding(topBottom = 10.px)
                ) {
                    CommonButton(
                        text = "Save",
                        isLoading = isLoading,
                        onCLick = {
                            scope.launch {

                                isLoading = true

                                if (keywordsList.isEmpty()) {
                                    keywordError = true
                                    keywordErrorText = "Press enter to confirm the keyword"
                                    isLoading = false
                                    return@launch
                                }

                                if (selectedCategory == "Selected Category") {
                                    isCategoryError = true
                                    isLoading = false
                                    return@launch
                                }

                                if (selectedLanguages == "Select Language") {
                                    isLanguageError = true
                                    isLoading = false
                                    return@launch
                                }

                                val payload = KeywordsPayload(
                                    keywordsList = keywordsList.toList(),
                                    keywordCategory = selectedCategory.lowercase(),
                                    organization = AppGlobal.userData.organization,
                                    language = mapLanguageToCode(selectedLanguages)
                                )


                                try {
                                    val apiResponse = createKeywords(payload)
                                    if (apiResponse.data.isNotEmpty()) {
                                        val refreshed = getCustomKeyword(CustomKeywordPayload(AppGlobal.userData.organization, seasonID = AppGlobal.selectedSeasonId))
                                        AppGlobal.clubKeywordsList.clear()
                                        AppGlobal.clubKeywordsList.addAll(refreshed.data)
                                        toastMessageCall("Keywords added successfully")
                                        showToast(ToastID.SUCCESS)
                                        onDialogDismiss()
                                    }

                                } catch (e: Exception) {
                                    serverError = e.message ?: "Something went wrong"
                                    debugPrintln("Create keyword ERROR: ${e.message}")

                                } finally {
                                    isLoading = false
                                }
                            }
                        },
                        width = 100.percent,
                        height = 45.px
                    )
                }

                if (serverError.isNotEmpty()) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        FieldTitleTextNormal(text = serverError,
                            color = sitePalette.textErrorColor.rgb,
                            fontSize = 12.px,
                            marginTop = 10.px,
                            textAlign = TextAlign.Center,
                            onClick = {})
                    }
                }
            }
        }
    }
}

fun mapLanguageToCode(language: String): String {
    return when (language) {
        "English" -> "en"
        "Spanish" -> "es"
        "French"  -> "fr"
        "Italian" -> "it"
        else -> ""
    }
}
